<template>
  <div>
    <div v-for="recipe in recipes" :key="recipe.id" class="recipe">
      <div v-if="type === 'output'">
        Using <small-items-list :items="recipe.items_tool" type="items" /> with
        <small-items-list :items="recipe.items_input" type="items" has-quantity />
      </div>

      <div v-if="type === 'input'">
        <strong>
          <small-items-list :items="recipe.items_output" type="items" />
        </strong>
        by using
        <small-items-list :items="recipe.items_tool" type="items" /> with
        <small-items-list :items="recipe.items_input" type="items" has-quantity />
      </div>

      <div v-if="type === 'tool'">
        <strong>
          <small-items-list :items="recipe.items_output" type="items" />
        </strong>
        by using
        <small-items-list :items="recipe.items_input" type="items" has-quantity />
      </div>

      <div v-if="recipe.required_skills.length > 0" class="has-text-grey is-size-7 mt-3">
        You need to have those skills learnt beforehand:
        <small-items-list :items="recipe.required_skills" type="skills" no-image />
      </div>

      <div v-if="recipe.required_achievements.length > 0" class="has-text-grey is-size-7 mt-3">
        You need to have those achievements beforehand:
        <small-items-list :items="recipe.required_achievements" type="achievements" no-image />
      </div>
    </div>
  </div>
</template>

<script>
import SmallItemsList from './SmallItemsList.vue';

export default {
  name: 'recipe-list',
  components: { SmallItemsList },
  props: {
    recipes: Array,
    type: String,
  },
};
</script>

<style scoped lang="scss">
.recipe ~ .recipe {
  border-top: 1px solid #ddd;
  padding-top: 20px;
  margin-top: 20px;
}
</style>
